import {
  Component,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { GlobalUtilityService } from 'src/app/core/services/global-utility.service';
import {
  APIResponse,
  ProductByCategory,
  productList,
} from '@AppRoot/shared/models/api-response.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { categories } from '@AppRoot/shared/models/common.interface';

declare var Swiper: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  // replace with your image URLs
  isLoggedIn: boolean = false;
  currentImageIndex = 0;
  featuringData: Array<productList> = [];
  productByCategory: Array<ProductByCategory> = [];
  banners: Array<{
    title: string;
    description: string;
    image_url: string;
    product_url: string;
  }> = [];
  category: Array<categories> = [];
  feedback: Array<{
    customer_name: string;
    profile_photo: string;
    description: string;
    rating: number;
    title: string;
  }> = [];
  blogList: any = [];
  screenWidth: number;

  imageLoaded = false;
  featuringCardLoaded = false;
  featuringCategoryLoaded = false;
  isModalVisible = false;
  currentVideoIndex = 0;
  mashhoorplusImages: Array<any> = [];

  constructor(
    private _globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService
  ) {
    this.screenWidth = window.innerWidth;
   
  }

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  offers: string[] = [
    '🔥 Free shipping on all products.',
    '🚚 10% off on prepaid orders!',
    '⚡ Get upto 50% off on combos!',
  ];

  responsiveOptions!:any;

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({
      left: -200,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({
      left: 200,
      behavior: 'smooth',
    });
  }

  ngOnInit() {
     this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];

    this._sharedService.MashhoorplusImages.subscribe({
      next: (data) => {
        this.mashhoorplusImages = data.filter(
          (d) => !d.name.includes('logo') && !d.name.includes('razorpay')
        );
      },
    });
    this._globalUtilityService.getLoginStatus().subscribe((status) => {
      this.isLoggedIn = status;
    });

    this.getFeaturingProducts();
    // this.getFeaturingCategory();
    this.getBanners();
    this.getFeedbacks();
    this._sharedService.fetchBlogs().subscribe({
      next: (data: any) => {
        this.blogList = data;
      },
      error: (error: any) => {
        this._globalUtilityService.showToast('Error', error.message);
      },
    });
    this._sharedService.categoryList.subscribe((res: any) => {
      this.category = res;
    });
  }

  ngAfterViewInit() {
    new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      autoplay: {
        delay: 2000, // Keeps autoplay behavior
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true, // Ensures smooth transitions
    });

    new Swiper('.swiper-container-feedback', {
      slidesPerView: 3,
      spaceBetween: 40,
      effect: 'coverflow',
      autoplay: {
        delay: 2000, // delay between transitions (in ms)
        disableOnInteraction: false, // continue autoplay after user interaction
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          effect: 'slide', // change effect to 'slide'
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
          effect: 'slide', // change effect to 'slide'
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 1,
          spaceBetween: 30,
          effect: 'slide', // change effect to 'slide'
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
          effect: 'coverflow',
        },
      },
    });
  }

  getIconClass(icon: string): string {
    return 'pi-' + icon;
  }

  getFeaturingProducts() {
    let param = {
      limit: 20,
      is_featured: 1,
    };
    this._sharedService.productList(param).subscribe({
      next: (res: APIResponse) => {
        this.featuringData = res.data.products;
        this.featuringCardLoaded = true;
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  getFeaturingCategory() {
    this._sharedService.getFeaturedCategoryProducts().subscribe({
      next: (res: APIResponse) => {
        this.featuringCategoryLoaded = true;
        console.log(res.data);
        this.productByCategory = res.data;
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  getBanners() {
    let screen = this.screenWidth < 768 ? 2 : 1;
    this._sharedService.getBanners(screen).subscribe({
      next: (res: APIResponse) => {
        this.banners = res.data;
        this.imageLoaded = true;
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  getFeedbacks() {
    this._sharedService.getCustomerFeedbacks().subscribe({
      next: (res: APIResponse) => {
        this.feedback = res.data;
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  redirectToProduct(category_id: number) {
    this._globalUtilityService.navigateToPath(`/products`, { category_id });
  }
}
